module.exports = __webpack_public_path__ + "static/frontUserNew/img/template-style.405239f5.gif";